import { Trans } from '@lingui/react/macro';
import type { ReactNode } from 'react';

import { Button } from '@/components/buttons';

type Props = {
  isEditMode: boolean;
  isSaveEnabled: boolean;
  isSaving: boolean;
  startContent?: ReactNode;
  showActions?: boolean;
  onEditModeChange: (isEditMode: boolean) => void;
  onCancel: () => void;
  onSave?: () => void;
};

const CompanySettingsActionBar = ({
  isEditMode,
  isSaveEnabled,
  isSaving,
  startContent,
  showActions = true,
  onEditModeChange,
  onCancel,
  onSave,
}: Props) => {
  return (
    <div className="sticky top-0 z-5 -m-4 -mx-8 flex items-center justify-between gap-4 bg-white p-4 px-8">
      <div>{startContent}</div>
      {showActions && (
        <div className="flex justify-end gap-4">
          {isEditMode ? (
            <>
              <Button disabled={isSaving} onClick={onCancel}>
                <Trans>Cancel</Trans>
              </Button>
              <Button
                variant="primary"
                isLoading={isSaving}
                disabled={!isSaveEnabled}
                type={onSave ? 'button' : 'submit'}
                onClick={onSave}
              >
                <Trans>Save Settings</Trans>
              </Button>
            </>
          ) : (
            <Button onClick={() => onEditModeChange(true)}>
              <Trans>Edit Settings</Trans>
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanySettingsActionBar;
